// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"e0540e6b","183":"39029bbb","184":"3806700f","323":"49fdd4d7","343":"f9856049","453":"6384b1ec","469":"4b2547b4","673":"79b2a380","754":"7f7b18e9","761":"cc4d2fd1","765":"884e8b13","973":"245bd3f1"}[chunkId] + ".chunk.js";
};